<template>
  <v-app id="app">
    <RootLayout />
    <ErrorToast />
    <!-- production 상태일때는 안나오게 수정 -->
    <Errors v-if="mode !== 'production'" />
  </v-app>
</template>
<script>
import { mapState } from 'vuex'

export default {
  metaInfo() {
    return this.metaInfo
  },
  name: 'App',
  components: {
    RootLayout: () => import('@/layouts/RootLayout'),
    Errors: () => import('@/components/error/FooterErrors.vue'),
    ErrorToast: () => import('@/components/error/ErrorToast.vue'),
  },
  data() {
    return {
      metaInfo: {},
    }
  },
  watch: {
    getMeta(value) {
      this.metaInfo = value
      this.$meta().refresh()
    },
  },
  computed: {
    ...mapState('env', ['mode']),
    ...mapState('meta', { getMeta: 'meta' }),
  },
}
</script>

<style lang="scss">
// `scoped` 제거
#app {
  .v-application--wrap {
    min-height: calc(var(--vh, 1vh) * 100) !important; // 덮어씌우기
  }
}
</style>
